const GetHouse = (token, projectId, cb) => {
  fetch(`${process.env.REACT_APP_API}/admin/api/dynamic/profiles?project_id=${projectId}&pageSize=5000`, {
  // fetch(`${process.env.REACT_APP_API}/admin/api/dynamic/profiles`, {       //product
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .then((json) => cb(null, json))
    .catch((err) => cb(err, null));
};

export default GetHouse;